// TODO: Make DAPI URL an environment variable instead of inferring it from the browser URL
function getRadarDapiUrl() {
  if (isLocalhostEnvironment()) {
    return 'http://localhost:8081/graphql'
  } else if (isDevEnvironment()) {
    return 'https://tech-radar-graph.dev.aws.wfscorp.com/graphql'
  } else {
    return 'https://tech-radar-graph.aws.wfscorp.com/graphql'
  }
}

function isLocalhostEnvironment() {
  const envHost = window.location.hostname
  return envHost.includes('localhost') || envHost.includes('0.0.0.0')
}

function isDevEnvironment() {
  const envHost = window.location.hostname
  return envHost.includes('dev')
}

function isTestEnvironment() {
  const envHost = window.location.hostname
  return envHost.includes('test')
}

function isQAEnvironment() {
  const envHost = window.location.hostname
  return envHost.includes('qa')
}

function getRadarAuth0Config() {
  if (isDevEnvironment()) {
    return {
      domain: 'auth.dev.wfscorp.com',
      clientId: 'pw3F4J3VDQeEC7JqUFkBi48WnBtRkmL0',
      authorizationParams: {
        audience: 'https://tech-radar-graph.wfscorp.com',
        redirect_uri: window.location.origin,
      },
    }
  } else if (isTestEnvironment()) {
    return {
      domain: 'auth.test.wfscorp.com',
      clientId: '3hBvDJrg9NIRoBvV6KVZ210M8WCE4GWb',
      authorizationParams: {
        audience: 'https://tech-radar-graph.wfscorp.com',
        redirect_uri: window.location.origin,
      },
    }
  } else if (isQAEnvironment()) {
    return {
      domain: 'auth.qa.wfscorp.com',
      clientId: '4CR6bipkS8vGkYqRt3hsBT92qwNakjn9',
      authorizationParams: {
        audience: 'https://tech-radar-graph.wfscorp.com',
        redirect_uri: window.location.origin,
      },
    }
  } else {
    return {
      domain: 'auth.wfscorp.com',
      clientId: 'Nri7Heu0jpVOmLWi0vS2ZpKj3cbSyiA0',
      authorizationParams: {
        audience: 'https://tech-radar-graph.wfscorp.com',
        redirect_uri: window.location.origin,
      },
    }
  }
}

module.exports = { getRadarDapiUrl, getRadarAuth0Config, isLocalhostEnvironment }
